import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import messages from '../../../messages/en.json';

import './main.scss';
import HomeSidebar from './_sidebar';
import HomeContent from './_content';

const Home = props => (
  <div className="main">
    <div className="main-sidebar">
      <HomeSidebar i18n={props.messages || messages}/>
    </div>
    <div className="main-content">
      <HomeContent/>
    </div>
  </div>
);

Home.propTypes = {
  i18n: PropTypes.object,
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
